export default __webpack_public_path__ + "e42bf98f076e16d7ef4b1e968248c64b.svg";